import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Note: StrictMode intentionally omitted. In development it double-mounts every
// component, which conflicts with react-leaflet's map lifecycle ("Map container
// is already initialized"). Production never double-mounts, so behavior is
// unchanged; this keeps dev consistent with production.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
